import * as React from "react";
import { Outlet } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import {Navbar, Nav, Row, Col} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'

function App() {

  return (

    <Container>

		<Navbar collapseOnSelect expand="lg"  bg="dark" data-bs-theme="dark">
			<Container>
				<Navbar.Brand href="#home">SMESHI EXPLORER</Navbar.Brand>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="responsive-navbar-nav">
					<Nav className="me-auto">
						<LinkContainer to='/'>
							<Nav.Link>Network</Nav.Link>
						</LinkContainer>
						
						<LinkContainer to='/accounts'>
							<Nav.Link>Accounts</Nav.Link>
						</LinkContainer>

						<LinkContainer to='/nodes'>
							<Nav.Link disabled>Nodes</Nav.Link>
						</LinkContainer>

						<LinkContainer to='/epochs'>
							<Nav.Link disabled>Epochs</Nav.Link>
						</LinkContainer>

						<LinkContainer to='/layers'>
							<Nav.Link disabled>Layers</Nav.Link>
						</LinkContainer>

						<LinkContainer to='/poets'>
							<Nav.Link disabled>PoETs</Nav.Link>
						</LinkContainer>
					</Nav>
				</Navbar.Collapse>

			</Container>

      </Navbar>

	<Row>
		<Col className="main-content">
			<Outlet />
		</Col>
	</Row>



	  <Navbar fixed="bottom" className="bg-body-tertiary">
        <Navbar.Collapse className="justify-content-center">
          <Navbar.Text>
            This site made possible by the: <a target='_blank'href="https://www.youtube.com/watch?v=BB3AU_DmKxk">Spacemesh Reward Tracker</a>
          </Navbar.Text>
        </Navbar.Collapse>
    </Navbar>

    </Container>
  );
}

export default App;
